import formatMoney from "lib/formatMoney";
import dayjs from "dayjs";

const CalculatorQuestions = [
  {
    q_id: "0",
    q_title: "Monthly rent",
    q_description: () => {
      return "What is the expected or actual monthly rental income?";
    },
    node_type: "node",
    a_type: "currency",
    a_input_type: "number",
    a_opts: () => [],
    q_next_step_func: (answer) => answer.q_id + "0",
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      return answerVal >= 0;
    },
    q_invalid_answer_help_text: "Please enter a value of 0 or greater",
    a_error: false,
  },
  {
    q_id: "00",
    q_title: "Monthly mortgage",
    q_description: () => {
      return "What is the expected or actual monthly mortgage income?";
    },
    node_type: "node",
    a_type: "currency",
    a_input_type: "number",
    a_opts: () => [],
    q_next_step_func: (answer) => answer.q_id + "0",
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      return answerVal >= 0;
    },
    q_invalid_answer_help_text: "Please enter a value of 0 or greater",
    a_error: false,
  },
  {
    q_id: "000",
    q_title: "Annual taxes",
    q_description: () => {
      return "What is the expected or actual annual taxes?";
    },
    node_type: "node",
    a_type: "currency",
    a_input_type: "number",
    a_opts: () => [],
    q_next_step_func: (answer) => answer.q_id + "0",
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      return answerVal >= 0;
    },
    q_invalid_answer_help_text: "Please enter a value of 0 or greater",
    a_error: false,
  },
  {
    q_id: "0000",
    q_title: "Annual insurance",
    q_description: () => {
      return "What is the expected or actual annual insurance?";
    },
    node_type: "node",
    a_type: "currency",
    a_input_type: "number",
    a_opts: () => [],
    q_next_step_func: (answer) => answer.q_id + "0",
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      return answerVal >= 0;
    },
    q_invalid_answer_help_text: "Please enter a value of 0 or greater",
    a_error: false,
  },
  {
    q_id: "00000",
    q_title: "Monthly reserve",
    q_description: () => {
      return "What is the expected or actual monthly reserve for maintenance?";
    },
    node_type: "node",
    a_type: "currency",
    a_input_type: "number",
    a_opts: () => [],
    q_next_step_func: (answer) => answer.q_id + "0",
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      return answerVal >= 0;
    },
    q_invalid_answer_help_text: "Please enter a value of 0 or greater",
    a_error: false,
  },
  {
    q_id: "000000",
    q_title: "Downpayment",
    q_description: () => {
      return "What is the expected or actual cash downpayment?";
    },
    node_type: "node",
    a_type: "currency",
    a_input_type: "number",
    a_opts: () => [],
    q_next_step_func: (answer) => answer.q_id + "0",
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      return answerVal >= 0;
    },
    q_invalid_answer_help_text: "Please enter a value of 0 or greater",
    a_error: false,
  },
  {
    q_id: "0000000",
    q_title: "Closing costs",
    q_description: () => {
      return "What is the expected or actual closing costs for this transaction?";
    },
    node_type: "node",
    a_type: "currency",
    a_input_type: "number",
    a_opts: () => [],
    q_next_step_func: (answer) => answer.q_id + "0",
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      return answerVal >= 0;
    },
    q_invalid_answer_help_text: "Please enter a value of 0 or greater",
    a_error: false,
  },
  {
    q_id: "00000000",
    q_title: "Calculation name",
    q_description: () => {
      return "What would you like to name this calculation. Ex. 'Escrow calc for 777 Happy Choice Rd.' ";
    },
    node_type: "node",
    a_type: "text",
    a_input_type: "text",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "",
    a_error: false,
  },
  {
    q_id: "000000000",
    q_title: "Address (optional)",
    q_description: () => {
      return "Enter property address to help organize your calculations. You can also enter a state, zip or nothing, since this field is optional.";
    },
    node_type: "node",
    a_type: "address",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_validation_func: (answerVal) => {
      //   make sure not false and a string of none 0 length
      if (!answerVal && !answerVal.length > 0) {
        return false;
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter or select an address",
    a_error: false,
  },
];

export default CalculatorQuestions;
